export enum CFDMediaType {
  VIDEO = 'Video',
  IMAGE = 'Image',
}

export const CFDMediaFileType = /^(image\/(png|jpeg|heic|heif|webp)|video\/)/;
